module.exports = __webpack_public_path__ + "static/img/img_home_3d.85176b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_home_3d.png
// module id = AOrI
// module chunks = 1